export default __webpack_public_path__ + "static/media/sms-outreach.8704ec12.svg";